import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { PersonalDetailType } from '../../components/common/CommonTypes';
import { logout } from '../actions';

// only holds initial customer data that came from api
// the current business logic does not imply changes once the data fetched

/**
 * Redux slice state for customer personal details.
 */
type SliceState = PersonalDetailType;

/**
 * Initial customer state.
 */
const initialSiteState: SliceState = {
  title: '',
  firstName: '',
  surname: '',
  email: '',
  confirmEmail: '',
  phone: '',
  addressDetails: {}
};

export const resetCustomer = () => initialSiteState;

/**
 * Customer slice containing reducers for storing any customer details returned by the backend.
 */
const customerSlice = createSlice({
  name: 'customer',
  initialState: initialSiteState,
  reducers: {
    /** Replaces the entire customer state with the provided payload. */
    setCustomer: (_, action: PayloadAction<SliceState>) => action.payload
  },
  extraReducers: (builder) => {
    /** Updates state on Logout action */
    builder.addCase(logout, resetCustomer);
  }
});

export const { setCustomer } = customerSlice.actions;

export default customerSlice.reducer;
